import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { IeAuthService } from '../../../app/services/ieauth.service';

@Component({
	selector: 'app-medios-pago',
	templateUrl: './medios-pago.component.html',
	styleUrls: ['./medios-pago.component.scss'],
})
export class MediosPagoComponent implements OnInit {
	mercadoAbierto = false;
	bancolombiaAbierto = false;
	bbvaAbierto = false;
	banagrarioAbierto = false;
	iecommerceAbierto = false;
	daviviendaAbierto = false;
	BogotaAbierto = false;

	inLanding: boolean = false

	constructor(
		private router: Router,
		private _ieauth: IeAuthService
	){
		
	}

	ngOnInit() {
		
		this.inLanding = this.router.url != '/recaudo-electronico'

		/* if( !this.inLanding && this._ieauth.origenUsuario.value){
			this.router.navigateByUrl('/cuenta/')
		} */
		this.mostrarBancolombia()

		// window.scrollTo(0, 0);
	}

	mostrarMercado(){
		this.mercadoAbierto = true// !this.mercadoAbierto;
		this.bancolombiaAbierto = false;
		this.bbvaAbierto = false;
		this.banagrarioAbierto = false;
		this.iecommerceAbierto = false;
		this.daviviendaAbierto = false;
		this.BogotaAbierto = false;
	}
	mostrarBancolombia() {
		this.bancolombiaAbierto = true // !this.bancolombiaAbierto;
		this.mercadoAbierto = false;
		this.bbvaAbierto = false;
		this.banagrarioAbierto = false;
		this.iecommerceAbierto = false;
		this.daviviendaAbierto = false;
		this.BogotaAbierto = false;
	}
	mostrarBbva(){
		this.bbvaAbierto = true //!this.bbvaAbierto;
		this.mercadoAbierto = false;
		this.bancolombiaAbierto = false;
		this.banagrarioAbierto = false;
		this.iecommerceAbierto = false;
		this.daviviendaAbierto = false;
		this.BogotaAbierto = false;
	}
	mostrarAgrario(){
		this.banagrarioAbierto = true//!this.banagrarioAbierto;
		this.mercadoAbierto = false;
		this.bancolombiaAbierto = false;
		this.bbvaAbierto = false;
		this.iecommerceAbierto = false;
		this.daviviendaAbierto = false;
		this.BogotaAbierto = false;
	}
	mostrarEcommmerce(){
		this.mercadoAbierto = false;
		this.bancolombiaAbierto = false;
		this.bbvaAbierto = false;
		this.banagrarioAbierto = false;
		this.iecommerceAbierto = true//  !this.iecommerceAbierto;
		this.daviviendaAbierto = false;
		this.BogotaAbierto = false;
	}
	mostrarDavivienda () {
		this.mercadoAbierto = false;
		this.bancolombiaAbierto = false;
		this.bbvaAbierto = false;
		this.banagrarioAbierto = false;
		this.iecommerceAbierto = false;
		this.daviviendaAbierto = true //!this.daviviendaAbierto;
		this.BogotaAbierto = false;
	}
	mostrarBogota(){
		this.mercadoAbierto = false;
		this.bancolombiaAbierto = false;
		this.bbvaAbierto = false;
		this.banagrarioAbierto = false;
		this.iecommerceAbierto = false;
		this.daviviendaAbierto = false;
		this.BogotaAbierto = true// !this.BogotaAbierto;
	}

	ocultarTodos(){
		this.mercadoAbierto = false;
		this.bancolombiaAbierto = false;
		this.bbvaAbierto = false;
		this.banagrarioAbierto = false;
		this.iecommerceAbierto = false;
		this.daviviendaAbierto = false;
		this.BogotaAbierto = false;
	}

}
